






































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class DeleteConfirm extends Vue {
  @Prop({ required: true })
  public item: any;

  @Prop({ required: true })
  public text: any;

  @Prop({ type: Boolean, default: false })
  public block;

  @Prop({ type: Boolean, default: false })
  public icon;

  @Prop({ required: false, default: true })
  public btnText;

  @Prop({ type: Boolean, default: false })
  public small!: boolean;

  private dialog = false;

  private confirm() {
    this.dialog = false;
    this.$emit("confirmed", this.item);
  }
}
